import {
  Actions,
  ConnectionState,
} from 'ha/modules/RealtimeMessaging/constants';

export const isConnectionUpdatedAction = action =>
  action.type === Actions.REALTIME_CONNECTION_UPDATED &&
  action.payload === ConnectionState.connected;
